import { SupportAdminDetailComponent } from "../../../components/SupportSystem/Admin/SupportAdminDetailComponent"
import { NavbarSupportSystem } from "../../../components/share/NavbarSupportSystem";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";
export function SupportAdminDetailContainer () {
    const titleName = "รายละเอียดคำขอรับเงินช่วยเหลือหรืออุดหนุน";
    return(
        <div className="page-container bg-landing">
            <NavbarSupportSystem  />
            <HeadTitle title={titleName} />
            <SupportAdminDetailComponent/>
            <Footer />
        </div>   
    )
}